import React, { useState } from 'react';
import { PatternError } from '../../pattern/stringToPattern';
import { EditSpeakOptions } from '../EditSpeakOptions';
import { MakeUpWord } from '../phonotactics/MakeUpWord';
import { CompactIpa } from './CompactIpa';
import { MakerState } from './makerState';
import { ReferenceChart } from './ReferenceChart';
import { Sonority } from './Sonority';

/** a page with tools for making the phonetic part of a language */
export function MakerArea() {
  // custom language data
  const [state] = useState<MakerState>(new MakerState());
  const [strSegments, setStrSegments] = useState(() => state.getSegmentsString());
  const [sonority, setSonority] = useState(() => state.getSonorityList());
  const [strDiphthongs, setDiphthongs] = useState(() => state.getDiphthongs());
  const [chartIpa, setChartIpa] = useState(() => state.getChartIpa());
  const [strPatterns, setStrPatterns] = useState(() => state.getPatternsString());
  const [scratchPatterns, setScratchPatterns] = useState(() => strPatterns);
  const [wordMaker, setWordMaker] = useState(() => state.getWordMaker());
  const [patternError, setPatternError] = useState<PatternError | null>(null);
  const [ptDirty, setPtDirty] = useState(false);

  function changeSegments(segments: string) {
    setStrSegments(segments);
    state.setSegmentsString(segments);
    setSonority(state.getSonorityList());
    setDiphthongs(state.getDiphthongs());
    setChartIpa(state.getChartIpa());
    setPtDirty(true);
  }
  function changePatterns(patterns: string) {
    const result = state.setPatternsString(patterns);
    if (result === true) {
      setStrPatterns(patterns);
      setPatternError(null);
      setWordMaker(state.getWordMaker());
      setPtDirty(false);
    } else {
      setPatternError(result);
    }
  }
  function changeScratchPhonotactics(phonotactics: string) {
    setScratchPatterns(phonotactics);
    setPtDirty(true);
  }

  function applySegments() {
    state.segmentsForPhonotactics();
    updatePatternsFromState();
  }
  function resetPhonotactics() {
    state.resetPhonotactics();
    updatePatternsFromState();
  }
  function updatePatternsFromState() {
    const str = state.getPatternsString();
    setStrPatterns(str);
    setScratchPatterns(str);
    setWordMaker(state.getWordMaker());
    setPtDirty(false);
  }

  function cleanSegments(segments: string) {
    // e.g., use the first phoneme in l̪|l
    const clean = segments.replaceAll(/(\|\S*)/g, '');
    changeSegments(clean);
  }

  return (<>
    <div>
      <div style={{ display: 'flex' }}>
        <div>
          <h2>Language Maker</h2>
          segments:&nbsp;
          <textarea cols={60} rows={5} spellCheck={false} value={strSegments} onChange={(event) => changeSegments(event.target.value)} />
          <br /><br />

          <button onClick={() => changePatterns(scratchPatterns)} disabled={!ptDirty}>apply patterns</button>
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          <button onClick={() => applySegments()}>use segments for onset and nucleus</button>
          &nbsp;&nbsp;&nbsp;&nbsp;
          <button onClick={() => resetPhonotactics()}>reset</button>
          {patternError ? <><br />error: {patternError.error}, at: {patternError.index}</> : <></>}
          <br />
          patterns:&nbsp;
          <textarea cols={60} rows={11} spellCheck={false} value={scratchPatterns} onChange={(event) => changeScratchPhonotactics(event.target.value)} />

          <br /><br />
          <MakeUpWord cols={50} wordMaker={wordMaker} />
        </div>
        <div>
          <h4>sorted by sonority</h4>
          <Sonority sonorityList={sonority} />
        </div>
        <div>
          <CompactIpa bolded={chartIpa} />
        </div>
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: 'auto 30%' }}>
        <div>
          <hr />
          <h3>References:</h3>
          <ReferenceChart customIpa={chartIpa} customDiphthongs={strDiphthongs} onSetSegments={cleanSegments} />
        </div>
      </div>
    </div>
    <hr />
    <EditSpeakOptions />
    <br /><br />
  </>
  );
}
